export const QuarantineHeader = () => (
  <header className="mb-6">
    <h1 className="font-GilroyBold text-2xl text-slate-900">Quarentena</h1>
    <p className="text-sm text-slate-600 mt-1">
      Selecione a data e a doca para finalizar a importação do Hora Certa para o
      Webcol. Cada ordem é salva individualmente.
    </p>
  </header>
);
